import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonTitle, IonToolbar } from '@ionic/vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToolbar), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_unref(IonTitle), null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Footer ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 3
  }))
}
}

})